import { useFieldHelper, FieldProps } from 'framework/ui/field';
import { CUSTOMER_REPORT_STATUS, CUSTOMER_REPORT_STATUS_OPTIONS } from 'domain/shared/newProject';
import { Typography, TypographyOwnProps } from '@mui/material';

const StatusField = ({ source }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const currentStatus = getValue();

  const color: Record<string, TypographyOwnProps['color']> = {
    [CUSTOMER_REPORT_STATUS.DRAFT]: 'textSecondary',
    [CUSTOMER_REPORT_STATUS.SENT]: 'success',
    [CUSTOMER_REPORT_STATUS.REJECTED]: 'error',
    [CUSTOMER_REPORT_STATUS.APPROVED]: 'success',
    [CUSTOMER_REPORT_STATUS.IN_APPROVAL]: 'warning',
    [CUSTOMER_REPORT_STATUS.CANCELED]: 'error',
  };

  const currentColor = color[currentStatus] || 'text.primary';

  const statusOption = CUSTOMER_REPORT_STATUS_OPTIONS[currentStatus] || currentStatus;
  return <Typography color={currentColor}>{statusOption}</Typography>;
};
export default StatusField;
